import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-main-container',
  styleUrl: 'main-container.css',
  shadow: false,
})
export class MainConainer {
  @Prop() max: string = 'var(--measure)';
  @Prop() gutters: string = 'var(--s0)';
  @Prop() andtext: boolean = false;
  @Prop() intrinsic: boolean = false;

  render() {
    return (
      <div class={`main-container ${this.andtext ? 'center' : ''} ${this.intrinsic ? 'intrinsic' : ''}`} style={{ '--gutters': this.gutters, '--max': this.max }}>
        <div>
          <slot />
        </div>
      </div>
    );
  }
}
